import config from '../../config'
import { buildGetQuery } from '../../util'

import { IGetRequestObject, ITrainingEvent } from '../../interfaces'

const getTrainingEventsRequest = (): IGetRequestObject => ({
  method: 'get',
  url: `${config.baseUrl}/TrainingEvents`,
})

const useTrainingEventsQuery = buildGetQuery<undefined, undefined, ITrainingEvent[] | undefined>({
  getRequest: getTrainingEventsRequest,
  getQueryKey: () => ['training-events'],
})

export default useTrainingEventsQuery